import axios, { AxiosResponse } from "axios";

// Authorization Settings
export const AuthApi = axios.create({
	baseURL: process.env.REACT_APP_AUTH_API
});

export const requestWithToken = axios.create({
	baseURL: process.env.REACT_APP_API_URL
});

export const requestWithoutToken = axios.create({
	baseURL: process.env.REACT_APP_API_URL
});

export const requestForFAQ = axios.create({
	baseURL: process.env.REACT_APP_FAQ_URL
});

export const FileApi = axios.create({
    baseURL: process.env.REACT_APP_FILE_API
});

export const generalRequest = axios.create({
	baseURL: process.env.REACT_APP_API_GENERAL
});

export const translationServiceRequest = axios.create({
    baseURL: process.env.REACT_APP_TRANSLATION_SERVICE,
});


function generateInterceptor(request: any, isFileApi?: boolean) {
	if (!isFileApi) {
        request.interceptors.request.use(
            function (config: any) {
                config.headers.Authorization = "Bearer " + localStorage.getItem("token");
                return config;
            },
            (error: any) => Promise.reject(error)
        );
        request.interceptors.response.use(
            (config: any) => config,
            (error: any) => {
                return Promise.reject(error);
            }
        );
    } else {
        request.interceptors.request.use(
            function (config: any) {
                const username = "mysoliq-file-api";
                const password = "fileapi123$";
                const basicAuth = 'Basic ' + btoa(username + ':' + password);
                config.headers.Authorization = basicAuth;
                return config;
            },
            (error: any) => Promise.reject(error)
        );
        request.interceptors.response.use(
            (config: any) => config,
            (error: any) => {
                return Promise.reject(error);
            }
        );
    }
}

function generateInterceptorWithoutToken(request: any) {
	request.interceptors.request.use(
		function (config: any) {
			return config;
		},
		(error: any) => Promise.reject(error)
	);
	request.interceptors.response.use(
		(config: any) => config,
		(error: any) => {
			return Promise.reject(error);
		}
	);
}
// export function generateAsyncInterceptor(
//     request: any,
// ) {
//     request.interceptors.request.use(
//         function (config: any) {
//             const token = localStorage.getItem("token");
//             if (token) {
//                 config.headers["Authorization"] = "Bearer " + token;
//             }
//             return config;
//         },
//         (error: any) => Promise.reject(error)
//     );
//     request.interceptors.response.use(
//         (config: any) => config,
//         (error: any) => {
//             if (error?.response?.status === 401) {
//                 const refreshToken = localStorage.getItem("refresh_token");
//                 requestWithToken.post("/auth/refresh-token", {
//                     // grant_type: "refresh_token",
//                     refreshToken: refreshToken,
//                 })
//             .then((token: AxiosResponse) => {
//                     localStorage.setItem("token", token?.data?.access_token);
//                     localStorage.setItem("refresh_token", token?.data?.refresh_token);
//                     // window.location.reload();
//                 })
//                     .catch(() => {
//                         setTimeout(() => {
//                             window.location.pathname = "/register";
//                             localStorage.clear();
//                         }, 500);
//                     });
//                 throw error;
//             }
//             return Promise.reject(error);
//         }
//     );
// }

// generateAsyncInterceptor(requestWithToken);
// generateAsyncInterceptor(AuthApi);
// generateAsyncInterceptor(generalRequest);
generateInterceptor(requestWithToken);
generateInterceptor(AuthApi);
generateInterceptor(generalRequest);
generateInterceptor(FileApi, true);
generateInterceptorWithoutToken(requestWithoutToken);
generateInterceptorWithoutToken(translationServiceRequest);
